import { render, staticRenderFns } from "./FinalDraftModal.vue?vue&type=template&id=4ec4851e&"
import script from "./FinalDraftModal.vue?vue&type=script&lang=js&"
export * from "./FinalDraftModal.vue?vue&type=script&lang=js&"
import style0 from "./FinalDraftModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports